import classNames from 'classnames/bind';
import styles from './DashIcons.module.css';

interface DashIconProps {
  cardId: string;
}

const ICON_MAP: Record<string, string> = {
  'last-learning': 'icon_study',
  'last-date': 'icon_atten',
  keyword: 'icon_keyword',
  tool: 'icon_tool',
  content: 'icon_content',
  'total-time': 'icon_total',
  'time-range': 'icon_slot',
  day: 'icon_week',
  book: 'icon_daily_pass',
  focus: 'icon_focus',
  note: 'icon_note',
};

const getIconClassName = (cardId: string): string => {
  return ICON_MAP[cardId] || 'icon_study';
};

export default function DashIcon({ cardId }: DashIconProps) {
  const cx = classNames.bind(styles);
  const iconClass = getIconClassName(cardId);

  return <i className={cx(iconClass)} />;
}
